
export const getFilterStudentsByGrades = (gradesArr, withoutAllBtn, setFilterStateFunc) => {
  const exampleGrades = [{id: 1, name: '7Б'}, {id: 2, name:'7В'}];
  let items = [];
  if (!withoutAllBtn) {
    items.push({ title: 'Все ученики', value: 'all' });
  }

  (gradesArr || exampleGrades).forEach((item) => {
    items.push({ title: item.name, value: item.id });
  })
  return {
    id: 'students',
    title: 'Ученики',
    type: 'checkbox',
    stateKey: 'studentsClassroomFilter',
    setStateAction: setFilterStateFunc,
    items: items,
  };
}
export const getFilterRows = (setFilterStateFunc) => {
  return {
    id: 'rows',
    title: 'Строки',
    type: 'radio',
    stateKey: 'rowsFiller',
    setStateAction: setFilterStateFunc,
    items: [
      {
        title: 'По ученикам',
        value: 'by_students',
      },{
        title: 'По классам',
        value: 'by_grade',
      }
    ],
  };
}

export const getFilterMeasure = (setFilterStateFunc) => {
  return {
    id: 'measure',
    title: 'Показатель',
    type: 'radio',
    stateKey: 'measureFilter',
    setStateAction: setFilterStateFunc,
    items: [
      {
        title: '% выполнения',
        value: 'by_percent_completion',
      },
      // {
      //   title: 'Количество попыток',
      //   value: 'by_count_trying',
      // },{
      //   title: 'Среднее время решения',
      //   value: 'by_solution_time',
      // }
    ],
  }
};

export const getFilterStudentsByPeriod = (setFilterStateFunc) => {
  return {
    id: 'period',
    title: 'Период',
    type: 'radio',
    withPeriodDatePicker: true,
    stateKey: 'periodFillerFragmentation',
    setStateAction: setFilterStateFunc,
    items: [
      {
        title: 'По неделям',
        value: 'by_weeks',
      },{
        title: 'По месяцам',
        value: 'by_months',
      },{
        title: 'По проверочным работам',
        value: 'by_homeworks',
      }
    ],
  }
};

export const getFilterStudentsByChapter = (setFilterStateFunc, chapters) => {
  const items = chapters.map(chapter => ({title: chapter.title, value: chapter.id}));
  return {
    id: 'chapter',
    title: 'Тема',
    type: 'select',
    stateKey: 'chapterFilter',
    setStateAction: setFilterStateFunc,
    reloadDefaultItems: chapters,
    items: items,
  }
};